const  AUDIO_PATH = "https://media.vancouver-live.fr/audio";
// const  AUDIO_PATH = "http://localhost/media/audio";

export default AUDIO_PATH;